import React from 'react';
import { get, isString } from 'lodash';
import { camelCase } from 'change-case';
import { useTranslation } from 'react-i18next';
import queryString from 'query-string';
import md5 from 'md5';
import { GeneralQuestionnaire } from './GeneralQuestionnaire';

const GeneralQuestionnaireApp = (props) => {
  const { selectedVisitorType, filteredQuestions, isEnableIfThenQuestionnaire } = props;
  const { t } = useTranslation();
  if (selectedVisitorType === undefined) {
    return null;
  }

  if (filteredQuestions.length === 0) {
    return null;
  }

  const language = queryString.parse(window.location.search).language || 'en';
  if (props.pagination) {
    return (
      <div>
        {filteredQuestions.map((lq, index) => {
          if (!isEnableIfThenQuestionnaire) {
            const question = lq;
            if (index % 2 === 0) {
              let hashedLabelTwo, inputNameTwo, inputPropsTwo;
              const label = isString(get(question, 'label')) ? question.label : get(question, `label["en"]`) || 'q';
              const hashedLabel = md5(camelCase(label), {
                algorithm: 'md5',
              });

              const inputName = `question_inputN_${question.uuid || question.inputN}_${hashedLabel}`;

              const inputProps = {
                inputName,
                ...question,
                ...props,
                label,
              };

              let questionTwo = filteredQuestions[index + 1];
              if (questionTwo) {
                const label = isString(get(questionTwo, 'label')) ? questionTwo.label : get(questionTwo, `label["en"]`) || 'q2';
                hashedLabelTwo = md5(camelCase(label), {
                  algorithm: 'md5',
                });

                inputNameTwo = `question_inputN_${questionTwo.inputN}_${hashedLabelTwo}`;

                inputPropsTwo = {
                  inputNameTwo,
                  ...questionTwo,
                  ...props,
                  label,
                };
              }

              return (
                <div id={3 + Math.round(index / 2)} className={'questionPart'} key={index}>
                  <p className="text-lg text-black font-bold text-center">{t('Questionnaire')}</p>
                  <p className="text-black mt-1 mb-2 text-xs italic">{t('Please answer the questionnaire below')}:</p>
                  <hr className="mt-2 mb-2" />
                  <GeneralQuestionnaire.Input key={inputName} {...inputProps} />
                  <GeneralQuestionnaire.Input key={inputNameTwo} {...inputPropsTwo} />
                </div>
              );
            }
            return '';
          }
          //one by one question
          const question = lq.question;
          const label = isString(get(question, 'label')) ? question.label : get(question, `label["en"]`) || 'q';
          const hashedLabel = md5(camelCase(label), {
            algorithm: 'md5',
          });
          const inputName = `question_inputN_${question.uuid || question.inputN}_${hashedLabel}`;

          const inputProps = {
            inputName,
            ...question,
            ...props,
            label,
          };

          return (
            <div id={3 + Math.round(index / 2)} className={'questionPart'} key={index}>
              <p className="text-lg text-black font-bold text-center">{t('Questionnaire')}</p>
              <p className="text-black mt-1 mb-2 text-xs italic">{t('Please answer the questionnaire below')}:</p>
              <hr className="mt-2 mb-2" />
              <GeneralQuestionnaire.Input key={inputName} {...inputProps} />
            </div>
          );
        })}
      </div>
    );
  }
  return (
    <div>
      <p className="text-lg text-black font-bold text-center">{t('Questionnaire')}</p>
      {/* <p className="text-white mt-1 mb-2 text-xs italic">{t('Please answer the questionnaire below:')}</p> */}
      <hr className="mt-2 mb-2" />

      {filteredQuestions.map((question) => {
        const englishFallbackLabel = get(question, `label[en]`) || '';
        const label = isString(get(question, 'label')) ? question.label : get(question, `label[${language}]`) || englishFallbackLabel;
        const hashedLabel = md5(camelCase(label), {
          algorithm: 'md5',
        });

        const inputName = `question_inputN_${question.inputN}_${hashedLabel}`;

        const inputProps = {
          inputName,
          ...question,
          ...props,
          label,
        };
        return <GeneralQuestionnaire.Input key={inputName} {...inputProps} />;
      })}
    </div>
  );
};

// GeneralQuestionnaire.Input = (props) => {
//   if (props.type === questionTypes.TEXT) {
//     return (
//       <div className="mb-4">
//         <label className="block text-white text-sm font-bold mb-2" htmlFor={props.inputName}>
//           {props.label}
//         </label>
//         <Field
//           className={`shadow appearance-none border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
//             props.errors[props.inputName] ? 'border-red-500' : ''
//           }`}
//           id={props.inputName}
//           name={props.inputName}
//           type="text"
//           placeholder={props.placeholder}
//           onChange={props.onChange}
//           value={props.values[props.inputName]}
//         />
//         {props.errors[props.inputName] ? <p className="text-red-500 text-xs italic">{props.errors[props.inputName]}</p> : null}
//       </div>
//     );
//   }

//   if (props.type === questionTypes.RADIOBUTTON) {
//     const onRadioButtonChange = (name, state) => {
//       props.values[name] = state;
//     };
//     return (
//       <div className="mb-4">
//         <p className="text-white">{props.label}</p>
//         <div className="text-white px-4 py-2">
//           <fieldset>
//             <input
//               className={`mr-2 ${props.errors[props.inputName] ? 'border-red-500' : ''}`}
//               type="radio"
//               id={'Y' + props.inputName}
//               name={props.inputName}
//               onChange={() => onRadioButtonChange(props.inputName, true)}
//             />
//             <label htmlFor={'Y' + props.inputName}>Yes</label>
//             <input className="mr-2 ml-4" type="radio" id={'N' + props.inputName} name={props.inputName} onChange={() => onRadioButtonChange(props.inputName, false)} />
//             <label htmlFor={'N' + props.inputName}>No</label>
//           </fieldset>
//           {props.errors[props.inputName] ? <p className="text-red-500 text-xs italic">{props.errors[props.inputName]}</p> : null}
//         </div>
//       </div>
//     );
//   }

//   if (props.type === questionTypes.CHECKBOX) {
//     return (
//       <div className="mb-4 text-white">
//         <p>{props.label}</p>
//         <div className="text-white px-4 py-2">
//           <fieldset>
//             <input className="mr-2" type="checkbox" id={props.inputName} name={props.inputName} onChange={props.onChange} value={props.values[props.inputName]} />
//             <label htmlFor={props.inputName}>Yes</label>
//           </fieldset>
//           {props.errors[props.inputName] ? <p className="text-red-500 text-xs italic">{props.errors[props.inputName]}</p> : null}
//         </div>
//       </div>
//     );
//   }

//   if (props.type === questionTypes.NUMBER) {
//     return (
//       <div className="mb-4">
//         <label className="block text-white text-sm font-bold mb-2" htmlFor={props.inputName}>
//           {props.label}
//         </label>
//         <input
//           className={`shadow appearance-none border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
//             props.errors[props.inputName] ? 'border-red-500' : ''
//           }`}
//           id={props.inputName}
//           name={props.inputName}
//           type="number"
//           step="0.1"
//           placeholder={props.placeholder}
//           onChange={props.onChange}
//           value={props.values[props.inputName]}
//         />
//         {props.errors[props.inputName] ? <p className="text-red-500 text-xs italic">{props.errors[props.inputName]}</p> : null}
//       </div>
//     );
//   }

//   if (props.type === questionTypes.NONRESPONSE) {
//     return (
//       <div className="mb-4 text-white">
//         <p>{props.label}</p>
//       </div>
//     );
//   }

//   return null;
// };

export default GeneralQuestionnaireApp;
